<xemex-table
  [data]="tableData()"
  [columns]="columns"
  [loading]="loading()"
  [rowLink]="rowLink"
  [pageable]="false"
>
  <ng-content></ng-content>
</xemex-table>
